<template>
  <b-row>
    <div v-for="(item, index) in itemsData" :key="'item-' + index" class="item-container">
      <div class="item">
        <nuxt-link :to="item.url">
          <img class="image" :src="item.image" height="520" :alt="item.name" />
          <div class="overlay">
            <h3 class="name">{{ item.name }}</h3>
          </div>
        </nuxt-link>
      </div>

      <div v-if="item.niches.length > 0">
        <ImagesLine :items="item.niches"></ImagesLine>
      </div>
    </div>
  </b-row>
</template>

<script>
import ImagesLine from '../Categories/ImagesLine';
export default {
  components: { ImagesLine },
  props: {
    items: {
      type: Array,
      required: true
    },
    marginLeft: {
      type: Number,
      required: false,
      default: 3
    },
    marginRight: {
      type: Number,
      required: false,
      default: 3
    }
  },
  data() {
    return {
      itemsData: [...this.items]
    };
  }
};
</script>

<style lang="scss" scoped>
.item-container {
  margin-bottom: 160px;
  width: 100%;
  @include md {
    margin-left: 20px;
    margin-right: 20px;
  }
}

.item {
  position: relative;
  height: 520px;
  margin-bottom: 20px;
  @include lg {
    height: 320px;
  }
  @include sm {
    height: 210px;
  }
}

.sub-item {
  position: relative;
  border-radius: 6px;
  @include md {
    height: 75px;
  }
}

.name {
  position: absolute;
  background-color: #00000045;
  text-shadow: 0px 3px 15px #000000b5;
  width: 100%;
  height: 100%;
  text-align: center;
  letter-spacing: 0.15px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  padding: 15px;
  font-size: 20px;
  transition: 0.4s;
}

.name:hover {
  cursor: pointer;
  background-color: #00000015;
  transition: 0.4s;
}

.sub-item-name {
  font-size: 16px;
  @include md {
    font-size: 12px;
  }
}

.sub-item-name:hover {
  cursor: pointer;
  background-color: #00000015;
  transition: 0.4s;
}

.image {
  display: block;
  width: 100%;
  @include lg {
    height: 320px;
  }
  @include sm {
    height: 210px;
  }
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
</style>
